<app-base-modal [open]="isOpen()" (openChange)="close()" title="Paper details" [size]="'md'">
  <div class="flex flex-col gap-3" data-testid="paper-info-modal">
    <!-- Loading state -->
    @if (loading()) {
      <div class="text-center py-8 text-gray-500">Loading paper details...</div>
    }

    <!-- Error state -->
    @if (error()) {
      <div class="rounded-md bg-red-50 px-3 py-2 text-sm text-red-800">
        {{ error() }}
      </div>
    }

    <!-- Paper content -->
    @if (paper(); as p) {
      <!-- Shared paper notice -->
      @if (otherProjectsCount() > 0) {
        <div
          class="rounded-md bg-blue-50 px-3 py-2 text-xs text-blue-800"
          data-testid="paper-info-shared-notice"
        >
          ⓘ This paper is also in {{ otherProjectsCount() }} other project(s) in this group.
        </div>
      }

      <div class="flex flex-col gap-3">
        <!-- Title -->
        <div class="flex flex-col gap-1">
          <label class="input-label">Title</label>
          <p class="text-sm text-gray-900 font-medium">{{ p.title }}</p>
        </div>

        <!-- Authors -->
        <div class="flex flex-col gap-1">
          <label class="input-label">Authors</label>
          <p class="text-sm text-gray-800">{{ authorsDisplay() }}</p>
        </div>

        <!-- Year + Venue -->
        <div class="flex flex-col gap-3 sm:flex-row">
          <div class="flex flex-1 flex-col gap-1">
            <label class="input-label">Year</label>
            <p class="text-sm text-gray-800">{{ year() ?? '—' }}</p>
          </div>
          <div class="flex flex-1 flex-col gap-1">
            <label class="input-label">Venue</label>
            <p class="text-sm text-gray-800">{{ p.venue || '—' }}</p>
          </div>
        </div>

        <!-- DOI -->
        <div class="flex flex-col gap-1">
          <label class="input-label">DOI</label>
          @if (doiUrl(); as url) {
            <a
              [href]="url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-sm text-blue-600 hover:text-blue-800 hover:underline break-all"
            >
              🔗 {{ url }}
            </a>
          } @else {
            <p class="text-sm text-gray-800">{{ p.doi || '—' }}</p>
          }
        </div>

        <!-- External ID -->
        @if (externalIdUrl(); as url) {
          <div class="flex flex-col gap-1" data-testid="paper-info-external-id">
            <label class="input-label">External ID</label>
            <a
              [href]="url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-sm text-blue-600 hover:text-blue-800 hover:underline break-all"
            >
              {{ url }}
            </a>
          </div>
        }

        <!-- Abstract -->
        <div class="flex flex-col gap-1">
          <label class="input-label">Abstract</label>
          <p class="text-sm text-gray-800 whitespace-pre-wrap">
            {{ p.abstractText || '—' }}
          </p>
        </div>

        <!-- Work type + Source type -->
        <div class="flex flex-col gap-3 sm:flex-row">
          <div class="flex flex-1 flex-col gap-1">
            <label class="input-label">Work type</label>
            <p class="text-sm text-gray-800">{{ p.workType || 'Unknown' }}</p>
          </div>
          <div class="flex flex-1 flex-col gap-1">
            <label class="input-label">Venue type</label>
            <p class="text-sm text-gray-800">{{ p.sourceType || 'Unknown' }}</p>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex justify-end gap-2">
          <button type="button" (click)="emitViewAuditTrail()" class="btn-small-secondary">
            View Audit Trail
          </button>
          <button
            type="button"
            (click)="close()"
            class="btn-primary"
            data-testid="paper-info-close"
          >
            Close
          </button>
        </div>
      </div>
    }
  </div>
</app-base-modal>
